var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4286_2438)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66797 -0.0244141C9.00977 -0.0244141 9.35156 -0.0244141 9.69336 -0.0244141C10.8795 0.291218 11.5875 1.05619 11.8174 2.27051C11.8418 3.26321 11.85 4.25605 11.8418 5.24902C10.7331 5.27026 9.62637 5.24585 8.52148 5.17578C7.27173 4.77148 6.60439 3.90885 6.51953 2.58789C6.62266 1.20754 7.33882 0.336773 8.66797 -0.0244141Z",
    fill: "#00BCD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.983,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2599 -0.0244141C15.6017 -0.0244141 15.9435 -0.0244141 16.2853 -0.0244141C17.3715 0.256079 18.0633 0.939673 18.3605 2.02637C18.4403 4.49896 18.4566 6.9729 18.4093 9.44824C18.1505 10.9287 17.2716 11.7262 15.7726 11.8408C14.283 11.747 13.4041 10.9658 13.1359 9.49707C13.0884 7.00527 13.1047 4.51505 13.1847 2.02637C13.482 0.939673 14.1737 0.256079 15.2599 -0.0244141Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.984,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0234375 9.69198C-0.0234375 9.35018 -0.0234375 9.00838 -0.0234375 8.66659C0.260699 7.56053 0.960566 6.86879 2.07617 6.59139C4.46764 6.51214 6.86021 6.49588 9.25391 6.54256C10.4673 6.6245 11.2893 7.23485 11.7197 8.37362C12.0503 9.72665 11.6353 10.7765 10.4746 11.523C10.1808 11.6698 9.87153 11.7675 9.54688 11.816C7.02227 11.8638 4.49949 11.8474 1.97852 11.7672C0.917813 11.4472 0.250495 10.7554 -0.0234375 9.69198Z",
    fill: "#00BCD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.982,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9757 8.81348C24.9757 9.07388 24.9757 9.33433 24.9757 9.59473C24.7023 10.8365 23.9373 11.5771 22.6808 11.8164C21.6881 11.8408 20.6952 11.849 19.7023 11.8408C19.6941 10.7828 19.7023 9.7248 19.7267 8.66699C20.0778 7.3231 20.9486 6.60698 22.339 6.51855C23.4491 6.58047 24.2547 7.10132 24.756 8.08105C24.8463 8.3269 24.9195 8.57104 24.9757 8.81348Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0234375 16.1867C-0.0234375 15.9263 -0.0234375 15.6658 -0.0234375 15.4054C0.26751 14.0697 1.09759 13.3129 2.4668 13.1349C3.41067 13.1105 4.35468 13.1023 5.29883 13.1105C5.31738 14.1861 5.29297 15.2603 5.22559 16.3331C4.90371 17.5014 4.14687 18.1931 2.95508 18.4083C1.69473 18.4974 0.775132 17.9847 0.196289 16.8702C0.106942 16.6415 0.0336999 16.4137 -0.0234375 16.1867Z",
    fill: "#E91E63"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.984,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69104 24.9756C9.34924 24.9756 9.00744 24.9756 8.66565 24.9756C7.58073 24.6964 6.88903 24.0128 6.59045 22.9248C6.51115 20.5008 6.49489 18.0756 6.54162 15.6494C6.75158 14.0967 7.63859 13.2504 9.20275 13.1104C10.6517 13.2492 11.5225 14.0304 11.8151 15.4541C11.8626 17.9622 11.8463 20.4687 11.7662 22.9736C11.4462 24.0343 10.7545 24.7017 9.69104 24.9756Z",
    fill: "#E91E63"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.984,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9746 15.2584C24.9746 15.6002 24.9746 15.942 24.9746 16.2838C24.7009 17.3471 24.0335 18.0388 22.9727 18.359C20.4514 18.4391 17.9286 18.4553 15.4043 18.4078C13.9708 18.1132 13.2058 17.2343 13.1094 15.7711C13.1882 14.5062 13.823 13.6598 15.0137 13.2321C15.2062 13.1836 15.4015 13.151 15.5996 13.1344C18.0421 13.0877 20.4835 13.1039 22.9238 13.1832C24.0105 13.4805 24.6941 14.1722 24.9746 15.2584Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.979,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2335 24.9752C15.908 24.9752 15.5825 24.9752 15.257 24.9752C14.0472 24.6523 13.3392 23.8711 13.1329 22.6314C13.1085 21.655 13.1004 20.6785 13.1085 19.7017C14.2172 19.6805 15.324 19.7049 16.4288 19.775C17.9224 20.2953 18.5653 21.3451 18.3576 22.9244C18.0547 24.033 17.3467 24.7166 16.2335 24.9752Z",
    fill: "#FF9800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4286_2438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.73d90a4588cdaac5debbf6dd3c49a29d.svg";
export { ForwardRef as ReactComponent };